export enum TriggerState {
    FILLED = 'filled',
    EMPTY = 'empty'
}

export interface TriggerProps {
    onClick: () => void
    label: string
    labelParts?: string[]
    isActive?: boolean
    state: TriggerState
    count?: number
    showCount?: boolean
    hideIndicator?: boolean
}